import { IconFileTypeCsv } from "@tabler/icons-react"
import { FilePreview } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import {
  formatBytes,
  formatFileDate,
} from "~/pages/Brand/DataTransfer/Import/const/ecoModulationImport.const"

type EcoModulationFilePreviewProps = {
  readonly file: File
  readonly hasFileError: boolean
  readonly fileErrorDetail: string
  readonly isFileBusy: boolean
  readonly busyLabel: string
  readonly isFileComplete: boolean
  readonly canRemove: boolean
  readonly isRemoveDisabled: boolean
  readonly isProgressActive: boolean
  readonly progressRunId: number
  readonly onRemove: () => void
}

export const EcoModulationFilePreview = ({
  file,
  hasFileError,
  fileErrorDetail,
  isFileBusy,
  busyLabel,
  isFileComplete,
  canRemove,
  isRemoveDisabled,
  isProgressActive,
  progressRunId,
  onRemove,
}: EcoModulationFilePreviewProps) => {
  const { t } = useTranslation(["dataTransfer", "common"])

  return (
    <FilePreview
      fileName={file.name}
      meta={t("dataTransfer:import.ecoModulation.summaryModal.fileMeta", {
        date: formatFileDate(file.lastModified),
        size: formatBytes(file.size),
      })}
      error={hasFileError ? fileErrorDetail : undefined}
      errorTitle={
        hasFileError
          ? t("dataTransfer:import.ecoModulation.summaryModal.uploadFailed")
          : undefined
      }
      isLoading={isFileBusy}
      busyLabel={busyLabel}
      completedText={
        isFileComplete
          ? t("dataTransfer:import.ecoModulation.summaryModal.completed")
          : undefined
      }
      progress={isFileBusy ? (isProgressActive ? 90 : 0) : undefined}
      progressRunId={progressRunId}
      canRemove={canRemove}
      isRemoveDisabled={isRemoveDisabled}
      removeAriaLabel={t("common:areYouSureModal.cancelText")}
      icon={<IconFileTypeCsv size={18} stroke={1.5} />}
      onRemove={onRemove}
      w="100%"
    />
  )
}
